import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator, TextHook2 as TextHook } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="fallback" num="0" mdxType="Translator" />
    <Translator page="fallback" num="0" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// './i18n/index.js'
const data = {
  en: {
    text: "Hello World!",
    text2: "Hello Universe!",
  },
  de: {
    text: "Hallo Welt!",
  },
};

export { data };
`}</code></pre>
    <Translator page="fallback" num="1" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from "react";
import { useI18n } from "react-i18n-kit";

import { data } from "./i18n";

const TextHook = () => {
  const { i18n } = useI18n(data, {
    lang: 'de',
    fallback: 'en',
  });

  return (
    <>
      <div>{i18n.text}</div>
      <div>{i18n.text2}</div>
    </>
  );
};

export { TextHook };
`}</code></pre>
    <Translator page="index" num="2" mdxType="Translator" />
    <Playground __position={4} __code={'<TextHook />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator,
      TextHook
    }} mdxType="Playground">
  <TextHook mdxType="TextHook" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      